import { configure, when } from 'mobx';

import routes from 'common/constants/routing.constants';
import { paramsToObject } from 'common/utils/common.utils';
import { captureError } from 'common/utils/error.util';
import history from 'customHistory';
import { stores } from 'stores';
import { IS_DISONA } from 'common/utils/style.util';
import { reportingService } from './reporting.service';
import { storageService } from './storage.service';
import { analyticsService } from './analytics.service';
import { iframeService } from './iframe.service';
import { i18nService } from './i18n.service';
import { wizardService } from './wizard.service';
import { metaService } from './meta.service';
import { authService } from './auth.service';
import { makeAccountService } from './make-account.service';
import { Notifier } from './notification.service';
import { signalsService } from './signals.service';

class AppService {
  initApp = () => {
    console.log(process.env, 'env');

    configure({ isolateGlobalState: true });

    const params = paramsToObject(new URLSearchParams(window.location.search));
    const { pathname } = window.location;
    stores.AuthStore.setInitialQueryParams(params);
    stores.AppStore.setInitialUrl(pathname);

    const { mid } = params;

    if (mid) {
      stores.AppStore.setPresetMasterID(mid);
    }

    iframeService.init();

    reportingService.init();

    storageService.init();

    analyticsService.init();

    i18nService.init();

    stores.AuthStore.initAuth({ initChat: true }).then(() => {
      if (stores.AuthStore.isAuthorised) metaService.postAuthRedirect();
    });

    authService.init();

    makeAccountService.init();

    Notifier.init();

    if (IS_DISONA) {
      signalsService.initSignals().then(() => {
        signalsService.signalsData();
      });
    }

    when(
      () => stores.AuthStore.isAuthorised,
      async () => {
        try {
          await metaService.fetchAccountsAndProfile();
          wizardService.init();
        } catch (error) {
          captureError(error);
        }
      }
    );

    window.appIsReady = true;
  };

  openRealAccount = () => {
    if (stores.ProfileStore.needInfo) {
      history.push(routes.profile.path);
    } else {
      history.push(routes.accountOpen.path);
    }
  };

  showCTAModal = (modal) => {
    const haveRealAccount = stores.AccountsStore.readyAccounts.some(
      (account) => account._account.account_type_info.is_trading
    );
    if (!haveRealAccount) {
      stores.ModalStore.showModal(modal);
    }
  };

  getServerCode = async (account) => {
    const servers = await stores.AccountsStore.getServers();
    const server = servers.find((el) => el.account_type_key === account);
    return server?.provider;
  };

  sendFreshChatEvent = (event) => {
    if (window.fcWidget) {
      // window.fcWidget.track(event);
      // IMPORTANT::: WE NEED ADD TAGS "profile-fil" ETC... TO FRESHCHAT ADMIN.
      // window.fcWidget.setTags([event]);
    } else {
      captureError(new Error('freshChat is not available in window namespace'));
    }
  };

  openChatOnPage = (event) => {
    if (window.fcWidget) {
      this.sendFreshChatEvent(event);
    } else {
      captureError(new Error('freshChat is not available in window namespace'));
    }
  };
}

export const appService = new AppService();
window.openChatOnPage = appService.openChatOnPage;
